import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import util from '@/lib/util';
import {
    PAGE_ROOT,
    PAGE_TABBAR_NAME,
    PAGE_TABBAR_DEFAULT_REDIRECT,
    PAGE_MAIN_MOVIE,
    PAGE_MAIN_CINEMA,
    PAGE_MAIN_MY,
    PAGE_SET_PASSWORD,
    PAGE_ORDER_LIST,
    PAGE_ORDER_INFO,
    PAGE_ORDER_BID,
    PAGE_SET_CITY,
    PAGE_MOVIE_INFO,
    PAGE_CINEMA_INFO,
    PAGE_MOVIE_SEAT_SELECTION,
    PAGE_PAY,
    PAGE_WECHAT_PAY,
    PAGE_PAY_CENTER_PAGE,
    PAGE_TICKET_TYPE,
    PAGE_MAP,
    PAGE_CUSTOMER_SERVICE,
    PAGE_COUPON_LIST,
    PAGE_COUPON_SELECT,
    PAGE_APPLY_SUPPLIER,
} from 'page';

const router = new Router({
    mode: 'history',
    routes: [
        {
            // 首页
            path: PAGE_ROOT,
            name: 'Index',
            meta: {
                zhCnName: '千猪',
                keepAlive: true,
            },
            redirect: PAGE_MAIN_MOVIE,
        },
        {
            // tabbar
            path: PAGE_TABBAR_NAME,
            name: 'Main',
            component: resolve => require(['@/page/main.vue'], resolve),
            redirect: PAGE_TABBAR_DEFAULT_REDIRECT,
            children: [
                {
                    // tabbar 电影
                    path: PAGE_MAIN_MOVIE,
                    name: 'MainMovie',
                    meta: {
                        zhCnName: '电影',
                        keepAlive: true,
                    },
                    component: resolve => require(['@/page/movie/index.vue'], resolve),
                },
                {
                    // tabbar 影院
                    path: PAGE_MAIN_CINEMA,
                    name: 'MainCinema',
                    meta: {
                        zhCnName: '影院',
                        keepAlive: true,
                    },
                    component: resolve => require(['@/page/cinema/index.vue'], resolve),
                },
                {
                    // tabbar 我的
                    path: PAGE_MAIN_MY,
                    name: 'MainMy',
                    meta: {
                        zhCnName: '我的',
                        keepAlive: true,
                    },
                    component: resolve => require(['@/page/user/my.vue'], resolve),
                },
            ],
        },
        // 用户模块
        {
            // 设置密码
            path: PAGE_SET_PASSWORD,
            name: 'SetPassword',
            meta: {
                zhCnName: '设置密码',
                keepAlive: true,
            },
            component: resolve => require(['@/page/user/setPassword.vue'], resolve),
        },
        // 电影模块
        {
            path: PAGE_MOVIE_INFO,
            name: 'MovieInfo',
            meta: {
                zhCnName: '',
                keepAlive: true,
            },
            component: resolve => require(['@/page/movie/info.vue'], resolve),
        },
        {
            path: PAGE_MOVIE_SEAT_SELECTION,
            name: 'MovieSeatSelection',
            meta: {
                zhCnName: '',
                keepAlive: true,
            },
            component: resolve => require(['@/page/movie/seatSelection.vue'], resolve),
        },
        // 影院模块
        {
            path: PAGE_CINEMA_INFO,
            name: 'CinemaInfo',
            meta: {
                zhCnName: '',
                keepAlive: true,
            },
            component: resolve => require(['@/page/cinema/info.vue'], resolve),
        },
        // 订单模块
        {
            path: PAGE_ORDER_LIST,
            name: 'OrderList',
            meta: {
                zhCnName: '我的订单',
                keepAlive: true,
            },
            component: resolve => require(['@/page/order/list.vue'], resolve),
        },
        {
            path: PAGE_ORDER_INFO,
            name: 'OrderInfo',
            meta: {
                zhCnName: '',
                keepAlive: false,
            },
            component: resolve => require(['@/page/order/info.vue'], resolve),
        },
        {
            path: PAGE_ORDER_BID,
            name: 'OrderBid',
            meta: {
                zhCnName: '',
                keepAlive: false,
            },
            component: resolve => require(['@/page/order/bid.vue'], resolve),
        },
        {
            path: PAGE_TICKET_TYPE,
            name: 'TicketType',
            meta: {
                zhCnName: '选择购票方式',
                keepAlive: true,
            },
            component: resolve => require(['@/page/order/ticketType'], resolve),
        },
        // 定位模块
        {
            path: PAGE_SET_CITY,
            name: 'SetCity',
            meta: {
                zhCnName: '选择城市',
                keepAlive: true,
            },
            component: resolve => require(['@/page/location/city.vue'], resolve),
        },
        // 地图模块
        {
            path: PAGE_MAP,
            name: 'Map',
            meta: {
                zhCnName: '影院位置',
                keepAlive: false,
            },
            component: resolve => require(['@/page/map/index.vue'], resolve),
        },
        // 支付模块
        {
            path: PAGE_PAY,
            name: 'Pay',
            meta: {
                zhCnName: '确认订单',
                keepAlive: false,
            },
            component: resolve => require(['@/page/pay/index.vue'], resolve),
        },
        {
            path: PAGE_PAY_CENTER_PAGE,
            name: 'payCenterPage',
            meta: {
                keepAlive: false,
                zhCnName: '',
            },
            component: resolve => require(['@/page/pay/centnerPage.vue'], resolve),
        },
        {
            path: PAGE_WECHAT_PAY,
            name: 'CommonWechatPay',
            meta: {
                zhCnName: '',
                keepAlive: false,
            },
            component: resolve => require(['@/page/pay/wechat.vue'], resolve),
        },
        // 优惠券模块
        {
            path: PAGE_COUPON_LIST,
            name: 'CouponList',
            meta: {
                zhCnName: '优惠券',
                keepAlive: false,
            },
            component: resolve => require(['@/page/coupon/list.vue'], resolve),
        },
        // 选择优惠券
        {
            path: PAGE_COUPON_SELECT,
            name: 'CouponSelect',
            meta: {
                zhCnName: '选择优惠券',
                keepAlive: false,
            },
            component: resolve => require(['@/page/coupon/select.vue'], resolve),
        },
        // 客服模块
        {
            path: PAGE_CUSTOMER_SERVICE,
            name: 'CustomerService',
            meta: {
                zhCnName: '在线客服',
                keepAlive: false,
            },
            component: resolve => require(['@/page/customer-service/index.vue'], resolve),
        },
        // 版本兼容 重定向原有url
        {
            path: '/pages/myOrder/index',
            name: 'oldOrderList',
            redirect: PAGE_ORDER_LIST,
        },
        {
            path: '/pages/orderDetail/index',
            name: 'oldOrderInfo',
            redirect: PAGE_ORDER_INFO,
        },
        {
            path: '/myPage/index',
            name: 'oldOrderList',
            redirect: PAGE_ORDER_LIST,
        },
        {
            path: PAGE_APPLY_SUPPLIER,
            name: 'applySupplier',
            meta: {
                zhCnName: '申请成为供应商',
                keepAlive: false,
            },
            component: resolve => require(['@/page/apply4Supplier/index.vue'], resolve),
        },
        {
            path: '*',
            redirect: PAGE_ROOT,
        },
    ],
});

Vue.use(Router);

export default router;
